import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { AddressSectionRedux, StepButtons } from "components";
import { reduxForm, getFormValues, FormSection } from "redux-form";
import { addressActions, uiActions } from "store";
import styles from "../stepper.module.scss";
import fp from "lodash/fp";
import { AddressStepType } from "types";
import { mapAddressToApi } from "mappers/geocodeAddress";

const FORM_NAME = "address";

type AddressStepProps = {
	nextStep: () => void;
	handleSubmit: (submitter: (values: any) => void) => void;
	prevStep: () => void;
	submitting: boolean;
	formValues: any;
	token: string;
};

let AddressStep = ({
	nextStep,
	handleSubmit,
	prevStep,
	submitting,
	dispatch,
	formValues,
	token,
}) => {
	useEffect(() => {
		if (submitting) {
			dispatch(uiActions.showSpinnerOverlay());
		}
		return () => dispatch(uiActions.hideSpinnerOverlay());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [submitting]);

	const applicationId = useSelector(
		(state: any) => state.generalInfo.applicationId,
	);

	const saveAddress = (values: AddressStepType) => {
		const businessLocation = mapAddressToApi?.(values.businessLocation);
		const legalBusinessLocation = mapAddressToApi?.(
			values?.legalBusinessLocation,
		);

		const payload = {
			is_legal_address_the_same:
				values?.legalBusinessLocation?.is_legal_address_the_same,
			business_address: businessLocation,
			legal_address:
				values?.legalBusinessLocation?.is_legal_address_the_same ===
				"true"
					? null
					: legalBusinessLocation,
			token,
			applicationId,
		};

		return dispatch(addressActions.sendAddress(payload)).then(nextStep);
	};

	return (
		<form onSubmit={handleSubmit(saveAddress)} className={styles.form}>
			<h1 className={styles.header}>Business Location Address</h1>

			<FormSection name="businessLocation">
				<AddressSectionRedux
					formName={FORM_NAME}
					sectionName="businessLocation.address"
					isRequired
				/>
			</FormSection>

			<FormSection name="legalBusinessLocation">
				<AddressSectionRedux
					formName={FORM_NAME}
					sectionName="legalBusinessLocation.address"
					isRequired
					isAddressTheSameLabel="Is legal address the same?"
					isAddressTheSameName="is_legal_address_the_same"
					isAddressTheSameValue={
						formValues?.legalBusinessLocation
							?.is_legal_address_the_same
					}
				/>
			</FormSection>

			<StepButtons
				initialTabIndex={13}
				nextStep={nextStep}
				prevStep={prevStep}
			/>
		</form>
	);
};

const mapStateToProps = state => ({
	formValues: getFormValues(FORM_NAME)(state) || {},
});

const AddressStepWithForm = reduxForm<AddressStepProps>({
	form: FORM_NAME,
	destroyOnUnmount: false,
})(AddressStep);

const AddressStepConnected = fp.flow(connect(mapStateToProps))(
	AddressStepWithForm,
);

export { AddressStepConnected as AddressStep };
